/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, IStackStyles, IStackTokens, ITextStyles, mergeStyleSets } from "@fluentui/react";

const theme = getTheme();

export const panelHeaderStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "32px",
    lineHeight: "40px",
    flexGrow: 1,
    margin: "24px",
  },
};

export const benefitLabelStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
  },
};

export const benefitStyles: ITextStyles = {
  root: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "22px",
  },
};

/**
 * The stack containing all of the form elements.
 */
export const containerStyles: IStackStyles = {
  root: {
    marginBottom: "1.5rem",
    backgroundColor: theme.palette.white,
    borderRadius: "8px",
    height: "100%",
  },
};

// Extend containerStyles to include margin-top
export const containerStylesWithMarginTop = mergeStyleSets(containerStyles, {
  root: {
    marginTop: "1rem",
  },
});

export const horizontalGapStackTokens: IStackTokens = {
  childrenGap: 10,
};
